export const SECTION_ID = 'MprExecutiveSummary';

export const removeDefaultDates = function() {
    $('input[data-role=datepicker]').each(function(index, item) {
        let $item = $(item),
            value = '';

        if ($item.data('kendoDatePicker')) {
            value = $item.data('kendoDatePicker').value();
            if (value !== null && value !== '' && value.getFullYear() <= 1901) {
                $item.data('kendoDatePicker').value('');
            }
        }
    });
};
export const setDefaultEvent = () => {
    $('input[data-role=numerictextbox]').each(function(index, item) {
        let $item = $(item);
        if (item.id !== 'WarrantyDuration') {
            $item.focus(function() {
                //Remove annoying zero default value
                let $ele = $(this);
                if ($ele.val() === '0') $ele.data('kendoNumericTextBox').value('');
            }).focusout(function() {
                //restore zero if left unanswered
                let $ele = $(this);
                if ($ele.val().length === 0) $ele.data('kendoNumericTextBox').value(0);
            });
        }
    });
};

// Calculations
// ===============================================================================
export const calculateDurations = function() {
    let $contractCompDate = $('#ContractCompleteDate'), $contractStartDate = $('#ContractStartDate'),
        $forecastCompDate = $('#ForecastCompDate'), $actualStartDate = $('#ActualStartDate');
    let contractEndDate,
        contractStartDate,
        diff,
        monthDiff,
        forecastComp,
        actualStartDate,
        todayJustDate,
        monthsElapsed,
        today = new Date(),
        dd = String(today.getDate()),
        mm = String(today.getMonth() + 1),
        yyyy = today.getFullYear(),
        percCompSched;
    todayJustDate = Date.parse(mm + '/' + dd + '/' + yyyy);

    if ($contractCompDate.val() !== '' && $contractStartDate.val() !== '') {
        contractEndDate = Date.parse($contractCompDate.val());
        contractStartDate = Date.parse($contractStartDate.val());
        diff = contractEndDate - contractStartDate;
        monthDiff = diff / 1000.0 / 60.0 / 60.0 / 24.0 / 30.0;

        $('#prMprExecSum_contractDuration').text(monthDiff.toFixed(0) + ' month(s)');
        $('#ContractDuration').val(monthDiff.toFixed(0));
    }

    if ($forecastCompDate.val() !== '' && $actualStartDate.val() !== '') {
        //forecast duration
        forecastComp = Date.parse($forecastCompDate.val());
        actualStartDate = Date.parse($actualStartDate.val());
        diff = forecastComp - actualStartDate;
        monthDiff = diff / 1000.0 / 60.0 / 60.0 / 24.0 / 30.0;
        $('#prMprExecSum_forecastDuration').text(monthDiff.toFixed(0) + ' month(s)');
        $('#ForecastDuration').val(monthDiff.toFixed(0));

        //perc comp (schedule)
        diff = todayJustDate - actualStartDate;
        monthsElapsed = diff / 1000.0 / 60.0 / 60.0 / 24.0 / 30.0;
        percCompSched = (monthsElapsed / monthDiff) * 100.00;
        $('#prMprExecSum_percCompSchedule').text(percCompSched.toFixed(1) + ' %');
    }

    if ($forecastCompDate.val() !== '') {
        forecastComp = Date.parse($forecastCompDate.val());
        diff = forecastComp - todayJustDate;
        monthDiff = diff / 1000.0 / 60.0 / 60.0 / 24.0 / 30.0;
        $('#prMprExecSum_monthsRemaining').text(monthDiff.toFixed(0) + ' month(s)');
    }
};

export function calculateErGpRemaining() {
    let $erFinish = $('input[id*=ErToFinish]');
    let $gpFinish = $('input[id*=GpToFinish]');
    let totalRev = parseFloat($erFinish.val()).toFixed(2);
    let runningTotal = Number(parseFloat($('[id*=Er1]').val() || 0).toFixed(2)) + Number(parseFloat($('[id*=Er2]').val() || 0).toFixed(2)) + Number(parseFloat($('[id*=Er3]').val() || 0)
        .toFixed(2)) + Number(parseFloat($('[id*=Er4]').val() || 0).toFixed(2));
    let remaining = totalRev - runningTotal;
    $('[id*=ErRemaining]').text(kendo.toString(remaining, '##,#.00'));

    let totalGp = parseFloat($gpFinish.val()).toFixed(2);
    runningTotal = Number(parseFloat($('[id*=Gp1]').val() || 0).toFixed(2)) + Number(parseFloat($('[id*=Gp2]').val() || 0).toFixed(2)) + Number(parseFloat($('[id*=Gp3]').val() || 0)
        .toFixed(2)) + Number(parseFloat($('[id*=Gp4]').val() || 0).toFixed(2));
    remaining = totalGp - runningTotal;
    $('[id*=GpRemaining]').text(kendo.toString(remaining, '##,#.00'));
}

//Event Functions
export const updateExecSummaryProjectSchedule = function() {
    let $datePickers = $('input[data-role=datepicker]');
    if ($datePickers.length) {
        $datePickers.change(function() {
            calculateDurations();
        });
    }
};
export const updateErGpRemaining = function() {
    let $erGp = $('input[id^=Er], input[id^=Gp]');
    if ($erGp.length) {
        $erGp.blur(function() {
            calculateErGpRemaining();
        });
    }
};
export const setNumericMax = function() {
    let $erGp = $('input[id^=Er].form-control, input[id^=Gp].form-control');
    if ($erGp.length) {
        $erGp.focus(function() {
            if (this.id !== 'ErToFinish' && this.id !== 'GpToFinish') {
                let section = this.id.substr(0, 2);
                let amountRemaining = parseFloat($('#' + section + 'Remaining').text().RemoveCharacters(',')),
                    k_ele = $(this).data('kendoNumericTextBox'), currentValue = k_ele.value();
                k_ele.max(currentValue + amountRemaining);
            }
        });
    }
};
